/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated.js';
import { compareDependencies } from './dependenciesCompare.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { partitionSelectDependencies } from './dependenciesPartitionSelect.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createQuantileSeq } from '../../factoriesAny.js';
export var quantileSeqDependencies = {
  addDependencies,
  compareDependencies,
  multiplyDependencies,
  partitionSelectDependencies,
  typedDependencies,
  createQuantileSeq
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesQuantileSeq.generated.js
// module id = 1444
// module chunks = 2